import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getGetVendorQueryOptions } from "@/requests/gen/react-query/vendor";
import VendorCreateForm from "../-form";
import { VendorCrumbs } from "../-crumbs";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_warehouse-360/vendor/$vendorId/edit",
)({
  loader: ({ context: { queryClient }, params: { vendorId } }) =>
    queryClient.ensureQueryData(getGetVendorQueryOptions(numericId(vendorId))),
  component: VendorEditPage,
});

function VendorEditPage() {
  const { vendorId } = Route.useParams();
  const { data: vendor } = useSuspenseQuery(
    suspenseOptions(getGetVendorQueryOptions(numericId(vendorId))),
  );

  return (
    <div>
      <title>
        {`Edit ${vendor?.name} Vendor Details - Legrande Health Portal`}
      </title>
      <VendorCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Edit Vendor</CardTitle>
          <CardDescription>Enter vendor details below.</CardDescription>
        </CardHeader>
        <CardContent>
          {vendor && <VendorCreateForm vendor={vendor} />}
        </CardContent>
      </Card>
    </div>
  );
}
